function showWhenVisible(selector) {
  const elements = document.querySelectorAll(selector);
  const sticky = document.querySelector(".sticky_add_to_cart");
  if (!elements.length) {
    console.log("No elements found for:", selector);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        sticky.classList.add("visible");
      }
    });
  });

  elements.forEach(el => observer.observe(el));
}

showWhenVisible(".section-product-description");

function hideWhenVisible(selector) {
  const elements = document.querySelectorAll(selector);
  const sticky = document.querySelector(".sticky_add_to_cart");
  if (!elements.length) {
    console.log("No elements found for:", selector);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        sticky.classList.remove("visible");
      }
    });
  });

  elements.forEach(el => observer.observe(el));
}

hideWhenVisible(".product-title");